import React from 'react';
import PropTypes from 'prop-types';
import ArticleCard from '@domain-group/fe-co-allhomes-article-card';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { Section } from '../structure';
var adviceImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/editorial-off-market-advice_88da6d0a.png";
import * as styles from './editorial.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var OffMarketAdvice = _ref => {
  var adviceUrl = _ref.adviceUrl;
  if (!adviceUrl) {
    return null;
  }
  return ___EmotionJSX(Section, null, ___EmotionJSX(EventBoundary, {
    name: "off-market-advice"
  }, ___EmotionJSX(ArticleCard, {
    css: styles.offMarketCard,
    article: {
      title: 'Getting ready to sell?',
      excerpt: 'Here are some articles that might be of interest to you.',
      image: adviceImage,
      url: adviceUrl,
      tags: [{
        slug: 'advice',
        label: 'Advice'
      }]
    },
    imagePosition: "top",
    target: "_blank",
    rel: "noopener"
  })));
};
OffMarketAdvice.propTypes = {
  adviceUrl: PropTypes.string
};
OffMarketAdvice.defaultProps = {
  adviceUrl: null
};
export default OffMarketAdvice;